var map = {
	"./": 371,
	"./assets/images/app-logo-b.svg": 346,
	"./assets/images/app-logo-w.svg": 1141,
	"./assets/images/auth-background.jpg": 227,
	"./assets/images/default-img.png": 92,
	"./assets/images/facility/In-room safe.svg": 1142,
	"./assets/images/facility/Refrigerator.svg": 1143,
	"./assets/images/facility/air-conditioner.svg": 1144,
	"./assets/images/facility/balcony.svg": 1145,
	"./assets/images/facility/bath-only.svg": 1146,
	"./assets/images/facility/bathtub-shower.svg": 1147,
	"./assets/images/facility/bathtub.svg": 1148,
	"./assets/images/facility/coffee-cup.svg": 1149,
	"./assets/images/facility/dishwasher.svg": 1150,
	"./assets/images/facility/dog.svg": 1151,
	"./assets/images/facility/dvd-palyer.svg": 1152,
	"./assets/images/facility/fan.svg": 1153,
	"./assets/images/facility/fireplace.svg": 1154,
	"./assets/images/facility/food.svg": 1155,
	"./assets/images/facility/hairdryer.svg": 1156,
	"./assets/images/facility/iron.svg": 1157,
	"./assets/images/facility/kitchen.svg": 1158,
	"./assets/images/facility/linen.svg": 1159,
	"./assets/images/facility/minibar.svg": 1160,
	"./assets/images/facility/movies.svg": 1161,
	"./assets/images/facility/no-smoking.svg": 1162,
	"./assets/images/facility/safe.svg": 1163,
	"./assets/images/facility/self-contained.svg": 1164,
	"./assets/images/facility/separate-bathroom-shower.svg": 1165,
	"./assets/images/facility/shower.svg": 1166,
	"./assets/images/facility/smoking-room.svg": 1167,
	"./assets/images/facility/spa.svg": 1168,
	"./assets/images/facility/telephone.svg": 1169,
	"./assets/images/facility/terrace.svg": 1170,
	"./assets/images/facility/tv.svg": 1171,
	"./assets/images/facility/wifi-signal.svg": 1172,
	"./assets/images/hotel-detail.jpg": 605,
	"./assets/images/hotelx.png": 182,
	"./assets/images/promo-1.jpg": 1173,
	"./assets/images/promo-2.jpg": 1174,
	"./assets/images/scan-border-1.svg": 1175,
	"./assets/images/scan-border.svg": 1176,
	"./assets/svg/CheckBoxIcon.svg": 1177,
	"./assets/svg/account/about-hotel.svg": 606,
	"./assets/svg/account/about-us.svg": 1178,
	"./assets/svg/account/address.svg": 607,
	"./assets/svg/account/call.svg": 608,
	"./assets/svg/account/change-pw.svg": 1179,
	"./assets/svg/account/cookie-policy.svg": 349,
	"./assets/svg/account/email.svg": 609,
	"./assets/svg/account/google-map.svg": 610,
	"./assets/svg/account/logout.svg": 1180,
	"./assets/svg/account/my-profile.svg": 1181,
	"./assets/svg/account/phone-no.svg": 611,
	"./assets/svg/account/privacy-policy.svg": 350,
	"./assets/svg/account/term-in-use.svg": 285,
	"./assets/svg/account/waze.svg": 612,
	"./assets/svg/booking/adult.svg": 348,
	"./assets/svg/booking/location.svg": 602,
	"./assets/svg/booking/no-smoking.svg": 603,
	"./assets/svg/booking/rating-star.svg": 347,
	"./assets/svg/booking/share.svg": 604,
	"./assets/svg/camera.svg": 613,
	"./assets/svg/cancel.svg": 351,
	"./assets/svg/chargetoroom.svg": 614,
	"./assets/svg/checkin-bed.svg": 615,
	"./assets/svg/checkin-review.svg": 616,
	"./assets/svg/completed.svg": 352,
	"./assets/svg/done.svg": 1182,
	"./assets/svg/edit.svg": 353,
	"./assets/svg/invoice.svg": 354,
	"./assets/svg/more.svg": 117,
	"./assets/svg/online-payment.svg": 617,
	"./assets/svg/order-review.svg": 618,
	"./assets/svg/person.svg": 355,
	"./assets/svg/rating/comment.svg": 619,
	"./assets/svg/rating/rate-facility.svg": 620,
	"./assets/svg/rating/rate-location.svg": 621,
	"./assets/svg/rating/rate-overall.svg": 622,
	"./assets/svg/rating/rate-property-condition.svg": 623,
	"./assets/svg/rating/rate-room.svg": 624,
	"./assets/svg/rating/rate-service.svg": 625,
	"./assets/svg/rating/rating.svg": 626,
	"./assets/svg/record.svg": 627,
	"./assets/svg/recording.svg": 628,
	"./assets/svg/remove.svg": 286,
	"./assets/svg/service/bill.svg": 629,
	"./assets/svg/service/bills.svg": 630,
	"./assets/svg/service/booking.svg": 631,
	"./assets/svg/service/checkout.svg": 632,
	"./assets/svg/service/directories.svg": 633,
	"./assets/svg/service/door.svg": 634,
	"./assets/svg/service/extend-stay.svg": 287,
	"./assets/svg/service/late-checkout.svg": 635,
	"./assets/svg/service/my-request.svg": 636,
	"./assets/svg/service/online-shop.svg": 637,
	"./assets/svg/service/package-redemption.svg": 638,
	"./assets/svg/service/promo-card-curves.svg": 639,
	"./assets/svg/service/room-services.svg": 640,
	"./assets/svg/service/scan-promo.svg": 641,
	"./assets/svg/service/scan.svg": 642,
	"./assets/svg/service/service-req.svg": 643,
	"./assets/svg/stay-duration.svg": 228,
	"./assets/svg/successful.svg": 644,
	"./components/InstallBanner/InstallBanner": 424,
	"./components/InstallBanner/InstallBanner.tsx": 424,
	"./components/InstallBanner/installbanner.scss": 1183,
	"./components/ScanID/ScanIDModal": 195,
	"./components/ScanID/ScanIDModal.tsx": 195,
	"./components/Skeleton/SkeletonCard": 356,
	"./components/Skeleton/SkeletonCard.tsx": 356,
	"./components/Skeleton/SkeletonList": 263,
	"./components/Skeleton/SkeletonList.tsx": 263,
	"./components/SnackBar/StyledSnackBar": 425,
	"./components/SnackBar/StyledSnackBar.tsx": 425,
	"./components/guestapp.scss": 791,
	"./components/styles/bills.scss": 1184,
	"./components/styles/extendstay.scss": 1185,
	"./components/styles/hotel.scss": 1186,
	"./components/styles/latecheckout.scss": 1187,
	"./containers/App": 261,
	"./containers/App/": 261,
	"./containers/App/Client": 107,
	"./containers/App/Client.ts": 107,
	"./containers/App/GuestLayout": 427,
	"./containers/App/GuestLayout.tsx": 427,
	"./containers/App/index": 261,
	"./containers/App/index.tsx": 261,
	"./containers/Context/Context": 26,
	"./containers/Context/Context.tsx": 26,
	"./containers/Context/Reducer": 225,
	"./containers/Context/Reducer.tsx": 225,
	"./containers/Context/Types": 805,
	"./containers/Context/Types.ts": 805,
	"./containers/Module/Account/AboutUs": 551,
	"./containers/Module/Account/AboutUs.tsx": 551,
	"./containers/Module/Account/AccountMenuOption": 272,
	"./containers/Module/Account/AccountMenuOption.tsx": 272,
	"./containers/Module/Account/ChangePassword": 552,
	"./containers/Module/Account/ChangePassword.tsx": 552,
	"./containers/Module/Account/MyProfile": 554,
	"./containers/Module/Account/MyProfile.tsx": 554,
	"./containers/Module/Account/OCRTest": 555,
	"./containers/Module/Account/OCRTest.tsx": 555,
	"./containers/Module/Account/Routes": 199,
	"./containers/Module/Account/Routes.tsx": 199,
	"./containers/Module/Auth": 190,
	"./containers/Module/Auth/": 190,
	"./containers/Module/Auth/ForgotPassword": 399,
	"./containers/Module/Auth/ForgotPassword.tsx": 399,
	"./containers/Module/Auth/ForgotPassword.txt": 1196,
	"./containers/Module/Auth/GraphQL/Account.graphql": 1197,
	"./containers/Module/Auth/Login": 395,
	"./containers/Module/Auth/Login.tsx": 395,
	"./containers/Module/Auth/Logout": 397,
	"./containers/Module/Auth/Logout.tsx": 397,
	"./containers/Module/Auth/NotFound": 398,
	"./containers/Module/Auth/NotFound.tsx": 398,
	"./containers/Module/Auth/OTPDialog": 265,
	"./containers/Module/Auth/OTPDialog.tsx": 265,
	"./containers/Module/Auth/Register": 396,
	"./containers/Module/Auth/Register.tsx": 396,
	"./containers/Module/Auth/ResetPassword.txt": 1198,
	"./containers/Module/Auth/Routes": 74,
	"./containers/Module/Auth/Routes.tsx": 74,
	"./containers/Module/Auth/index": 190,
	"./containers/Module/Auth/index.tsx": 190,
	"./containers/Module/Booking/Booking": 556,
	"./containers/Module/Booking/Booking.tsx": 556,
	"./containers/Module/Booking/BookingDetail/AddPopOver": 440,
	"./containers/Module/Booking/BookingDetail/AddPopOver.tsx": 440,
	"./containers/Module/Booking/BookingDetail/BookingDetail": 557,
	"./containers/Module/Booking/BookingDetail/BookingDetail.tsx": 557,
	"./containers/Module/Booking/CheckIn/CheckInSummary": 558,
	"./containers/Module/Booking/CheckIn/CheckInSummary.tsx": 558,
	"./containers/Module/Booking/CheckIn/ERegistration": 559,
	"./containers/Module/Booking/CheckIn/ERegistration.tsx": 559,
	"./containers/Module/Booking/CheckInOutDate": 438,
	"./containers/Module/Booking/CheckInOutDate.tsx": 438,
	"./containers/Module/Booking/FilterOption": 439,
	"./containers/Module/Booking/FilterOption.tsx": 439,
	"./containers/Module/Booking/GraphQL/Booking.graphql": 1209,
	"./containers/Module/Booking/GraphQL/CheckIn.graphql": 1210,
	"./containers/Module/Booking/GraphQL/Hotel.graphql": 1211,
	"./containers/Module/Booking/GraphQL/Payment.graphql": 1212,
	"./containers/Module/Booking/Hotel": 163,
	"./containers/Module/Booking/Hotel/": 163,
	"./containers/Module/Booking/Hotel/BookingSummary": 400,
	"./containers/Module/Booking/Hotel/BookingSummary.tsx": 400,
	"./containers/Module/Booking/Hotel/BookingSummaryDialog": 268,
	"./containers/Module/Booking/Hotel/BookingSummaryDialog.tsx": 268,
	"./containers/Module/Booking/Hotel/HotelDetail": 391,
	"./containers/Module/Booking/Hotel/HotelDetail.tsx": 391,
	"./containers/Module/Booking/Hotel/HotelList": 390,
	"./containers/Module/Booking/Hotel/HotelList.tsx": 390,
	"./containers/Module/Booking/Hotel/PackageOption": 436,
	"./containers/Module/Booking/Hotel/PackageOption.tsx": 436,
	"./containers/Module/Booking/Hotel/RatingReview": 401,
	"./containers/Module/Booking/Hotel/RatingReview.tsx": 401,
	"./containers/Module/Booking/Hotel/RoomTypeDetail": 402,
	"./containers/Module/Booking/Hotel/RoomTypeDetail.tsx": 402,
	"./containers/Module/Booking/Hotel/TaxesFeeDialog": 442,
	"./containers/Module/Booking/Hotel/TaxesFeeDialog.tsx": 442,
	"./containers/Module/Booking/Hotel/index": 163,
	"./containers/Module/Booking/Hotel/index.ts": 163,
	"./containers/Module/Booking/Routes": 45,
	"./containers/Module/Booking/Routes.tsx": 45,
	"./containers/Module/Services/AdsDetail": 560,
	"./containers/Module/Services/AdsDetail.tsx": 560,
	"./containers/Module/Services/Bills": 561,
	"./containers/Module/Services/Bills.tsx": 561,
	"./containers/Module/Services/CheckOutDialog": 269,
	"./containers/Module/Services/CheckOutDialog.tsx": 269,
	"./containers/Module/Services/Directories/Directories": 562,
	"./containers/Module/Services/Directories/Directories.tsx": 562,
	"./containers/Module/Services/Directories/DirectoriesDetail": 563,
	"./containers/Module/Services/Directories/DirectoriesDetail.tsx": 563,
	"./containers/Module/Services/ExtendStay": 564,
	"./containers/Module/Services/ExtendStay.tsx": 564,
	"./containers/Module/Services/GraphQL/Bills.graphql": 1213,
	"./containers/Module/Services/GraphQL/CheckOut.graphql": 1214,
	"./containers/Module/Services/GraphQL/ExtendStay.graphql": 1215,
	"./containers/Module/Services/GraphQL/Inhouse.graphql": 1216,
	"./containers/Module/Services/GraphQL/InvoiceDoc.graphql": 1217,
	"./containers/Module/Services/GraphQL/LateCheckout.graphql": 1218,
	"./containers/Module/Services/GraphQL/Request.graphql": 1219,
	"./containers/Module/Services/GraphQL/Services.graphql": 1220,
	"./containers/Module/Services/InvoiceDocument": 403,
	"./containers/Module/Services/InvoiceDocument.tsx": 403,
	"./containers/Module/Services/LateCheckOut": 565,
	"./containers/Module/Services/LateCheckOut.tsx": 565,
	"./containers/Module/Services/PackageRedemption": 566,
	"./containers/Module/Services/PackageRedemption.tsx": 566,
	"./containers/Module/Services/PaymentDialog": 197,
	"./containers/Module/Services/PaymentDialog.tsx": 197,
	"./containers/Module/Services/RateStay": 567,
	"./containers/Module/Services/RateStay.tsx": 567,
	"./containers/Module/Services/Request": 164,
	"./containers/Module/Services/Request/": 164,
	"./containers/Module/Services/Request/Order": 408,
	"./containers/Module/Services/Request/Order.tsx": 408,
	"./containers/Module/Services/Request/RecordButton.txt": 1229,
	"./containers/Module/Services/Request/Request": 407,
	"./containers/Module/Services/Request/Request.tsx": 407,
	"./containers/Module/Services/Request/ServiceRequest": 404,
	"./containers/Module/Services/Request/ServiceRequest.tsx": 404,
	"./containers/Module/Services/Request/ServiceRequestDetail": 406,
	"./containers/Module/Services/Request/ServiceRequestDetail.tsx": 406,
	"./containers/Module/Services/Request/ServiceRequestForm": 405,
	"./containers/Module/Services/Request/ServiceRequestForm.tsx": 405,
	"./containers/Module/Services/Request/Summary": 409,
	"./containers/Module/Services/Request/Summary.tsx": 409,
	"./containers/Module/Services/Request/index": 164,
	"./containers/Module/Services/Request/index.ts": 164,
	"./containers/Module/Services/RequestDrawer": 446,
	"./containers/Module/Services/RequestDrawer.tsx": 446,
	"./containers/Module/Services/Routes": 23,
	"./containers/Module/Services/Routes.tsx": 23,
	"./containers/Module/Services/Services": 569,
	"./containers/Module/Services/Services.tsx": 569,
	"./containers/Routes": 260,
	"./containers/Routes/": 260,
	"./containers/Routes/PrivateRoute": 435,
	"./containers/Routes/PrivateRoute.tsx": 435,
	"./containers/Routes/RootRoutes": 284,
	"./containers/Routes/RootRoutes.tsx": 284,
	"./containers/Routes/ScrollToTop": 447,
	"./containers/Routes/ScrollToTop.tsx": 447,
	"./containers/Routes/index": 260,
	"./containers/Routes/index.tsx": 260,
	"./containers/Utils/CommonTypes": 810,
	"./containers/Utils/CommonTypes.ts": 810,
	"./containers/Utils/Enum": 159,
	"./containers/Utils/Enum.ts": 159,
	"./containers/Utils/OCRhelper": 171,
	"./containers/Utils/OCRhelper.ts": 171,
	"./containers/Utils/RatingAvg": 267,
	"./containers/Utils/RatingAvg.ts": 267,
	"./containers/Utils/Snippets.txt": 1230,
	"./containers/Utils/Template/Invoice": 358,
	"./containers/Utils/Template/Invoice.ts": 358,
	"./containers/Utils/b64toBlob": 441,
	"./containers/Utils/b64toBlob.ts": 441,
	"./containers/Utils/numFormatter": 39,
	"./containers/Utils/numFormatter.ts": 39,
	"./containers/hooks/useBlinkID": 437,
	"./containers/hooks/useBlinkID.tsx": 437,
	"./containers/hooks/useInstallPrompt": 426,
	"./containers/hooks/useInstallPrompt.tsx": 426,
	"./containers/hooks/useMenuOption": 196,
	"./containers/hooks/useMenuOption.tsx": 196,
	"./containers/hooks/usePhoneValidation": 266,
	"./containers/hooks/usePhoneValidation.tsx": 266,
	"./containers/hooks/useRecorder.txt": 1231,
	"./containers/hooks/useUploadAttachment": 445,
	"./containers/hooks/useUploadAttachment.tsx": 445,
	"./generated/graphql": 10,
	"./generated/graphql.tsx": 10,
	"./index": 371,
	"./index.tsx": 371,
	"./logo.svg": 1232,
	"./react-app-env.d": 811,
	"./react-app-env.d.ts": 811,
	"./reportWebVitals": 448,
	"./reportWebVitals.ts": 448,
	"./service-worker": 812,
	"./service-worker.ts": 812,
	"./serviceWorkerRegistration": 455,
	"./serviceWorkerRegistration.ts": 455,
	"./setupTests": 813,
	"./setupTests.ts": 813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;